import React, { FunctionComponent, useMemo } from 'react';
import { Stepper, StepperStep } from '../../../../shared/general';
import {
  CalculatorAdditionalPaymentStepperStep1,
  CalculatorAdditionalPaymentStepperStep2
} from './steps';
import { useIntl, IntlShape } from 'react-intl';

interface StepsArray {
  component: FunctionComponent<{ id: number; title?: string }>;
  hide: boolean;
  title: string;
}

const getSteps = (intl: IntlShape): StepsArray[] => {
  const step1Title = intl.formatMessage({ id: 'step1.title', defaultMessage: 'Hypotheek' });
  const step2Title = intl.formatMessage({ id: 'step2.title', defaultMessage: 'Aflossen' });

  return [
    {
      component: CalculatorAdditionalPaymentStepperStep1,
      hide: false,
      title: step1Title
    },
    {
      component: CalculatorAdditionalPaymentStepperStep2,
      hide: false,
      title: step2Title
    }
  ];
};

export const CalculatorAdditionalPaymentStepper: FunctionComponent = () => {
  const intl = useIntl();

  const steps = useMemo(() => getSteps(intl), [intl]);

  return (
    <Stepper previousButtonTexts={[steps[0].title]}>
      {steps.map(({ component: StepComponent, hide, title }, key) => (
        <StepperStep id={key} hide={hide} key={key}>
          <StepComponent id={key} title={title} />
        </StepperStep>
      ))}
    </Stepper>
  );
};
